import { type Module } from "vuex";
import type { State as RootState } from "@/stores";
import type { AutomatedInviteExcludedStage, DefaultApi } from "@/api";

export interface State {
  excludedStages?: AutomatedInviteExcludedStage[];
}

export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    excludedStages: undefined,
  },
  actions: {
    async getAutomatedInviteExcludedStages({ commit }) {
      const api = (await this.dispatch("getAuthorizedApi", null, {
        root: true,
      })) as DefaultApi;
      try {
        const response = await api.getAutomatedInviteExcludedStages();
        commit("setExcludedStages", response.data ?? []);
        return response.data ?? [];
      } catch (error) {
        commit("setExcludedStages", []);
        throw error;
      }
    },
    async postAutomatedInviteExcludedStages(
      { commit },
      applicationStageIds: number[],
    ) {
      const api = (await this.dispatch("getAuthorizedApi", null, {
        root: true,
      })) as DefaultApi;
      const response = await api.postAutomatedInviteExcludedStages({
        application_stage_ids: applicationStageIds,
      });
      commit("setExcludedStages", response.data ?? []);
      return response.data ?? [];
    },
  },
  mutations: {
    setExcludedStages(state, excludedStages: AutomatedInviteExcludedStage[]) {
      state.excludedStages = excludedStages;
    },
  },
};
